import { render, staticRenderFns } from "./withdrawalRecordData.vue?vue&type=template&id=8b079dee&scoped=true"
import script from "./withdrawalRecordData.vue?vue&type=script&lang=js"
export * from "./withdrawalRecordData.vue?vue&type=script&lang=js"
import style0 from "./withdrawalRecordData.vue?vue&type=style&index=0&id=8b079dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b079dee",
  null
  
)

export default component.exports